module.exports = __webpack_public_path__ + "img/Hearder.3fc21ad0.png";